import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api";
import {BaseBackEND} from "../../services/auth"


import Card1 from "../../assets/img/banners/card1.png"
import Card2 from "../../assets/img/banners/card2.png"


import Cardenfermangem from "../../assets/img/banners/box_courses/enfermagem.jpg"
import CardenfADM from "../../assets/img/banners/box_courses/adm.jpg"
import CARDGD from "../../assets/img/banners/box_courses/gestaoedesenvolvimento.jpg"

class CourseFeaturesIndex extends Component {

  state= {
    cursos:[]
  }





  async componentWillReceiveProps(nextProps) {
   
    const {idcategoria} = nextProps;

    const response1 = await api.post("/cursoscomlimite/categoria", {idunidade:localStorage.getItem('idunidade'),idcategoria});
    this.setState({ 
      cursos: response1.data
    })
    

 

  }


  async componentWillMount(){

    const {idcategoria} = this.props;

    const response1 = await api.post("/cursoscomlimite/categoria", {idunidade:localStorage.getItem('idunidade'),idcategoria:this.props.idcategoria});
    this.setState({ 
      cursos: response1.data
    })

  }



  
  render() {
    return (
    <React.Fragment>
    <div class="container catologo-cursod">
  <div class="row imgcursos">
   
                  {this.state.cursos.map(el => (
                     el.isgraduation==0 &&
                   <div class="col-lg-4">
                      <div class="card">
                            
                        
                        
                              <div class="card-body">
                              
                              <center>  
                              {el.idcategoria!=16 &&
                                <a href={'/pos-graduacao/'+el.longnome+'/'+el.id+''} class="card-title">{el.nome}</a>
                              }
                              {el.idcategoria==16 &&
                                <a href={'/Curso-Curta-Duracao/'+el.longnome+'/'+el.id+''} class="card-title">{el.nome}</a>
                              }
                              
                              </center>
                              </div>
                 
                      </div>
                
                  </div>

                  ))}
                 

    

                 
    </div>
    <div class="text-center mt-4">
                <a href="/pos-graduacao" class="btn btn-primary btn-sm">Ver mais</a>
              </div>
</div>
            
        
    </React.Fragment>
       
    );
  }
}

export default withRouter(CourseFeaturesIndex);


// WEBPACK FOOTER //
// ./src/pages/content/coursesfeature.js